define("shared/components/shared/post/secondary/hashtag-suggestions/item", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr class={{if this.isCheckboxActive "is--selected"}} {{on "click" (fn @selectHashtag @hashtag)}}>
    <td class="cMH--td__title u--p__l__lg">
      <div class={{concat-classes "cMH--td__text u--ellipsis" @qaClass}}>
        {{t "hashtag_suggestions.hashtag_value" value=@hashtag.hashtag}}
        <EmberTooltip>
          {{t "hashtag_suggestions.hashtag_value" value=@hashtag.hashtag}}
        </EmberTooltip>
        <div class="u--text--sm u--text--light">
          {{this.numPosts}}
        </div>
      </div>
    </td>
    <td class={{if this.isHighRelevance "u--text--success"}}>
      {{this.relevance}}
    </td>
    <td>
      {{#if this.isCheckboxActive}}
        {{svg-jar "verified" class="o--icon--md o--icon--hl o--table__checkbox is--checked"}}
      {{else}}
        {{svg-jar "verified" class="o--icon--md o--icon--light o--table__checkbox"}}
      {{/if}}
    </td>
  </tr>
  */
  {
    "id": "vgdo6ShM",
    "block": "[[[11,\"tr\"],[16,0,[52,[30,0,[\"isCheckboxActive\"]],\"is--selected\"]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],[30,2]],null]],null],[12],[1,\"\\n  \"],[10,\"td\"],[14,0,\"cMH--td__title u--p__l__lg\"],[12],[1,\"\\n    \"],[10,0],[15,0,[28,[37,3],[\"cMH--td__text u--ellipsis\",[30,3]],null]],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"hashtag_suggestions.hashtag_value\"],[[\"value\"],[[30,2,[\"hashtag\"]]]]]],[1,\"\\n      \"],[8,[39,5],null,null,[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"hashtag_suggestions.hashtag_value\"],[[\"value\"],[[30,2,[\"hashtag\"]]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[10,0],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n        \"],[1,[30,0,[\"numPosts\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[15,0,[52,[30,0,[\"isHighRelevance\"]],\"u--text--success\"]],[12],[1,\"\\n    \"],[1,[30,0,[\"relevance\"]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,0,[\"isCheckboxActive\"]],[[[1,\"      \"],[1,[28,[35,6],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--hl o--table__checkbox is--checked\"]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,6],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--light o--table__checkbox\"]]]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@selectHashtag\",\"@hashtag\",\"@qaClass\"],false,[\"if\",\"on\",\"fn\",\"concat-classes\",\"t\",\"ember-tooltip\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/item.hbs",
    "isStrictMode": false
  });
  let ItemComponent = _exports.default = (_class = class ItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _defineProperty(this, "hashtagRelevances", {
        HIGH: 'high',
        MEDIUM: 'medium',
        LOW: 'low'
      });
    }
    get relevance() {
      const canViewHashtagRelevance = this.auth.currentAccount.canSmartHashtags || this.subscriptions.subscriptionPlan.hasLimitedHashtagSearches;
      if (!this.auth.currentAccount.isOnLegacyPlan && canViewHashtagRelevance) {
        return this.intl.t(`hashtag_suggestions.relevance.${this.args.hashtag.relevance}`);
      }
      return this.intl.t('hashtag_suggestions.relevance_value', {
        value: this.args.hashtag.calculatedScore
      });
    }
    get isHighRelevance() {
      return !this.auth.currentAccount.isOnLegacyPlan && this.auth.currentAccount.canSmartHashtags && this.args.hashtag.relevance === this.hashtagRelevances.HIGH;
    }
    get isCheckboxActive() {
      const {
        selectedHashtags
      } = this.args;
      const tag = this.args.hashtag;
      return selectedHashtags && tag ? selectedHashtags.find(_tag => _tag.hashtag === tag.hashtag) : false;
    }
    get hideNumPosts() {
      return !this.auth.currentAccount.isOnLegacyPlan;
    }
    get numPosts() {
      const {
        noPosts,
        unviewable,
        num_posts,
        formattedNumPosts
      } = this.args.hashtag;
      if (this.hideNumPosts) {
        return '';
      }
      if (noPosts) {
        return this.intl.t('hashtag_suggestions.item.empty');
      }
      if (unviewable) {
        return this.intl.t('hashtag_suggestions.item.unviewable');
      }
      return this.intl.t('hashtag_suggestions.item.count', {
        count: num_posts,
        value: formattedNumPosts
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ItemComponent);
});